// components/ServerDatabase/ServerList.jsx
import React from 'react';
import ServerCard from './ServerCard';

const ServerList = ({ servers, loading, onServerHover, onStartTesting }) => {
  if (loading) {
    return (
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
        {[...Array(6)].map((_, index) => (
          <div key={index} className="bg-dark-600 rounded-2xl p-5 animate-pulse transform-gpu hover:scale-[1.02] transition-medium">
            <div className="h-24 bg-dark-500 rounded-t-2xl mb-4"></div>
            <div className="h-4 bg-dark-500 rounded w-3/4 mb-2"></div>
            <div className="h-3 bg-dark-500 rounded w-1/2 mb-4"></div>
            <div className="h-3 bg-dark-500 rounded w-full mb-2"></div>
            <div className="h-3 bg-dark-500 rounded w-5/6"></div>
          </div>
        ))}
      </div>
    );
  }

  if (!servers.length) {
    return (
      <div className="text-center py-10 transform-gpu transition-medium hover:scale-[1.01]">
        <i className="fas fa-server text-4xl text-gray-400 mb-4 animate-float"></i>
        <p className="text-gray-400 group-hover:text-white transition-medium">
          No servers found matching your criteria
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
      {servers.map((server, index) => (
        <ServerCard
          key={server.ip || index} // Use server.ip for a more stable key if available
          {...server}
          onHover={() => onServerHover && onServerHover(server)} // Check if prop exists
          onHoverEnd={() => onServerHover && onServerHover(null)} // Check if prop exists
          onStartTesting={() => onStartTesting(server.ip)} // Pass the server IP
        />
      ))}
    </div>
  );
};

export default ServerList;